<template>
  <button
    :class="computedClass('card-counter')"
    data-testid="card-counter"
    :disabled="disabled"
    @click="handleClick"
  >
    <span class="content">
      <span class="section">
        <BaseIcon :icon="icon" :class="computedClass('icon')" />
        <div :class="computedClass('section__badge')">{{ badgeCounter }}</div>
      </span>
      <span :class="computedClass('label')">
        {{ label }}
      </span>
    </span>
  </button>
</template>

<script setup lang="ts">
import { BaseIcon } from '@warrenbrasil/nebraska-web';

const emit = defineEmits(['click']);

interface Props {
  badgeCounter?: string | number;
  label: string;
  icon: string;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), { badgeCounter: '0' });

const computedClass = (className: string) => {
  return {
    [className]: true,
    [`${className}--disabled`]: props.disabled
  };
};

const handleClick = async () => {
  if (!props.disabled) {
    emit('click');
  }
};
</script>

<style lang="less" scoped>
.card-counter {
  background: @background-tertiary;
  width: 100%;
  height: 132px;
  padding: @size-spacing-x400;
  border-radius: @size-radius-x300;
  opacity: 1;

  &--disabled {
    background: @background-secondary;
    border: 1px solid @divider-primary;
    cursor: not-allowed;

    &:hover {
      transition: none !important;
      transform: none;
      background: @background-secondary !important;
    }
  }

  &:hover {
    background: @background-hover;
  }
}

.content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: space-between;
}

.icon {
  padding: @size-spacing-x150;
  color: @element-primary;
  &--disabled {
    color: @element-disabled;
  }
}

.section {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__badge {
    padding: @size-spacing-x75 @size-spacing-x300;
    background-color: @element-primary;
    color: @base-primary;
    border-radius: @size-radius-max;

    &--disabled {
      background-color: @element-disabled;
    }
  }
}

.badge-counter {
  .text-p-6();
  padding: 1px @size-spacing-x300;
  color: @element-primary;
  background-color: @theme-secondary;

  &--disabled {
    color: @base-primary;
    background-color: @element-disabled;
  }
}

.label {
  .text-p-4();
  color: @text-primary;
  font-weight: 600;
  &--disabled,
  &--disabled > :deep(*) {
    color: @element-disabled !important;
  }
}
</style>
